var _defs, _rect, _rect2, _rect3, _rect4, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _rect5, _rect6, _rect7, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIntegrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 400",
    role: "img",
    "aria-label": "Epicor ERP connected to CRM, e-commerce, EDI, Power BI, REST APIs and SQL",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d1a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sun",
    cx: 0.08,
    cy: 1,
    r: 0.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4a582",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4a582",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky",
    cx: 0.95,
    cy: 0,
    r: 0.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fb6e3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fb6e3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 30,
    height: 30,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30",
    fill: "none",
    stroke: "#4fb6e3",
    strokeOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hub",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fb6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f7fb5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "halo",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fb6e3",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fb6e3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "l1",
    d: "M160 90C210 90 205 178 245 182"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l2",
    d: "M160 200H245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l3",
    d: "M160 310C210 310 205 222 245 218"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r1",
    d: "M355 182C395 178 390 90 440 90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r2",
    d: "M355 200H440"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r3",
    d: "M355 218C395 222 390 310 440 310"
  }), /*#__PURE__*/React.createElement("style", null, "\n      .ring { transform-origin: 300px 200px; animation: pulse 3.5s ease-out infinite; }\n      .ring2 { animation-delay: 1.75s; }\n      @keyframes pulse { from { transform: scale(0.75); opacity: 0.6; } to { transform: scale(1.35); opacity: 0; } }\n      @media (prefers-reduced-motion: reduce) { .ring { animation: none; opacity: 0.25; } }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#grid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#sun)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#sky)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("use", {
    href: "#l1",
    stroke: "#4fb6e3",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#l2",
    stroke: "#f4a582",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("use", {
    href: "#l3",
    stroke: "#4fb6e3",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#r1",
    stroke: "#f4a582",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("use", {
    href: "#r2",
    stroke: "#4fb6e3",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#r3",
    stroke: "#f4a582",
    strokeOpacity: 0.45
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#4fb6e3"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.6s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#l1"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#f4a582"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.2s",
    begin: "-0.8s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#l2"
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#4fb6e3"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.9s",
    begin: "-1.5s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#l3"
  })))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#f4a582"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.4s",
    begin: "-0.4s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#r1"
  })))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#4fb6e3"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.1s",
    begin: "-1.2s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#r2"
  })))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#f4a582"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.8s",
    begin: "-2s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#r3"
  })))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 200,
    r: 120,
    fill: "url(#halo)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "ring",
    x: 235,
    y: 135,
    width: 130,
    height: 130,
    rx: 28,
    fill: "none",
    stroke: "#4fb6e3",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "ring ring2",
    x: 235,
    y: 135,
    width: 130,
    height: 130,
    rx: 28,
    fill: "none",
    stroke: "#f4a582",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 145,
    width: 110,
    height: 110,
    rx: 24,
    fill: "url(#hub)",
    stroke: "#fbe3cf",
    strokeOpacity: 0.6,
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Segoe UI','Helvetica Neue',Arial,sans-serif",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 205,
    fontSize: 30,
    fontWeight: 800,
    fill: "#ffffff",
    letterSpacing: 1
  }, "ERP"), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 229,
    fontSize: 13,
    fontWeight: 600,
    fill: "#e6f4fb"
  }, "Epicor Kinetic"), /*#__PURE__*/React.createElement("g", {
    fontSize: 14,
    fontWeight: 600,
    fill: "#e8eaf0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 68,
    width: 130,
    height: 44,
    rx: 10,
    fill: "#0f2233",
    stroke: "#4fb6e3",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 90,
    r: 5,
    fill: "#4fb6e3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 95
  }, "CRM"), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 178,
    width: 130,
    height: 44,
    rx: 10,
    fill: "#0f2233",
    stroke: "#f4a582",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 200,
    r: 5,
    fill: "#f4a582"
  }), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 205
  }, "E-Commerce"), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 288,
    width: 130,
    height: 44,
    rx: 10,
    fill: "#0f2233",
    stroke: "#4fb6e3",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 310,
    r: 5,
    fill: "#4fb6e3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 315
  }, "EDI"), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 68,
    width: 130,
    height: 44,
    rx: 10,
    fill: "#0f2233",
    stroke: "#f4a582",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 90,
    r: 5,
    fill: "#f4a582"
  }), /*#__PURE__*/React.createElement("text", {
    x: 512,
    y: 95
  }, "Power BI"), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 178,
    width: 130,
    height: 44,
    rx: 10,
    fill: "#0f2233",
    stroke: "#4fb6e3",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 200,
    r: 5,
    fill: "#4fb6e3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 512,
    y: 205
  }, "REST API"), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 288,
    width: 130,
    height: 44,
    rx: 10,
    fill: "#0f2233",
    stroke: "#f4a582",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 310,
    r: 5,
    fill: "#f4a582"
  }), /*#__PURE__*/React.createElement("text", {
    x: 512,
    y: 315
  }, "SQL")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIntegrations);
export default __webpack_public_path__ + "static/media/home-integrations.220c350badb126be53dc04bcee17cf09.svg";
export { ForwardRef as ReactComponent };